import React, { useCallback } from 'react';
import ChannelFilter from './components/ChannelFilter';
// import ChannelDashboard from './components/ChannelDashboard';
// import ChannelTable from './components/ChannelTable';
import { styled } from 'styled-components';
import ChannelItem from './components/ChannelItem';
import useGetListChannels from 'modules/channel/services/hooks/useGetListChannels';
import toast from 'utils/toast';
import { useAppDispatch } from 'store/hooks';
import channelActions from 'modules/channel/services/actions';
import { useNavigate } from 'react-router-dom';
import { Button } from 'basic-ui-lib';
import ModalConfirm, { useModalConfirmRef } from 'widgets/ModalConfirm';

const ChannelManangementPage = () => {
  const [listChannels, mutate] = useGetListChannels();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const modalConfirmRef = useModalConfirmRef();

  const handleDeleteChannel = useCallback((id: string) => {
    try {
      dispatch(channelActions.deleteChannel.fetch(id));
      toast.success('Delete channel successfully');
    } catch (error) {
      toast.error('Delete channel failed');
    }
  }, [dispatch]);

  const handleNavigateToChannelDetail = useCallback((id: string) => {
    navigate(`/channel/${id}`);
  }, [navigate]);


  const loadMore = async () => {
    if (listChannels?.hasMore) {
      mutate({
        from: (listChannels?.from || 0) + 1,
        size: 10,
      });
    }
  };

  const handleDelete = (channel: any) => {
    modalConfirmRef.current?.open(() => handleDeleteChannel(channel.id), {
      message: `Are you sure you want to delete the channel "${channel.name}"? This action cannot be undone.`,
    });
  };

  return (
    <Container>
      <ChannelFilter />
      {/* <ChannelDashboard /> */}
      {/* <ChannelTable /> */}
      <Content>
        {listChannels?.content.map((channel) => (
          <ChannelItem key={channel.id} channel={channel} onDelete={() => handleDelete(channel)} onSetToScreen={handleNavigateToChannelDetail}/>
        ))}
      </Content>
      {listChannels?.hasMore &&
        <Button type_cancel lg className='show-more-button' onClick={loadMore}>
          Show more
        </Button>
      }
      <ModalConfirm ref={modalConfirmRef} />
    </Container>
  );
};

export default ChannelManangementPage;

const Container = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .show-more-button {
    width: fit-content;
    margin: 0 auto;
  }
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
`;
